<div [ngClass]="{ 'mat-tree-node-active': active }">
  <a mat-button [routerLink]="getUrl()" class="sidenav-nested">
    {{ menuNode.label }}
    @if (showTickerCounter()) {
      <span class="tickers-quick-amount">{{ amountOfTickers }}</span>
    }
  </a>
</div>
